import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
export class PaymentChannelAmountBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('data-bb-payment-subchannels');
    }

    protected installBehaviour(element: HTMLElement): void {
        $(element).on('change', '[name = "SelectedSubChannel"]', function () {
            const selectedSCh = $('[name = "SelectedSubChannel"]:checked');

            const amount = $('[name=Amount]', element).first();
            amount.form().removeData('validator');

            $('.js-min', element).text(
                selectedSCh.attr('data-bb-subchannels-min-amount')
            );
            $('.js-max', element).text(
                selectedSCh.attr('data-bb-subchannels-max-amount')
            );

            amount.attr(
                'data-val-minvalue-min',
                selectedSCh.attr('data-bb-subchannels-min')
            );
            amount.attr(
                'data-val-maxvalue-max',
                selectedSCh.attr('data-bb-subchannels-max')
            );
            amount.attr(
                'data-val-minvalue',
                selectedSCh.attr('data-bb-subchannels-min-amount-text')
            );
            amount.attr(
                'data-val-maxvalue',
                selectedSCh.attr('data-bb-subchannels-max-amount-text')
            );

            Validators.parse(amount.form());
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.PaymentChannelAmountBehaviour = PaymentChannelAmountBehaviour;